import { Box, BoxProps, CardProps, Tooltip } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

import {
  checkColorContrast,
  MaskedIcon,
  resolveIcon,
} from "../../pm-components/utils";

export interface TableUpdateStatusCellProps {
  /** cell header */
  header?: string;
  /** cell body text */
  body: string;
  /** icon beside the body text */
  icon?: string;
  /** MUI icon beside the body text note: this only gets used if the icon prop is not set. */
  muiIcon?: string;
  /** chip background color */
  chipColor?: string;
  /** tooltip text shown on hover */
  tooltip?: string;
  /** Additional MUI styling */
  cardProps?: CardProps;
  /** Additional header styling */
  headerProps?: BoxProps;
  /** chip props */
  chipProps?: BoxProps;
}

export const TableUpdateStatusCell: PimoReactComponent<
  TableUpdateStatusCellProps
> = ({
  header,
  body,
  icon,
  muiIcon,
  chipColor,
  tooltip,
  cardProps = {},
  chipProps = {},
  headerProps = {},
}) => {
  const chipSx = (chipProps.sx || {
    color: "#000000",
    backgroundColor: "#ffffff",
  }) as BoxProps["sx"] & { color: string; backgroundColor: string };

  const color = checkColorContrast({
    backgroundColor: chipColor || chipSx.backgroundColor,
    textColor: chipSx.color,
  })?.textColor;

  const resolvedMuiIcon = resolveIcon(muiIcon);
  const chip = (
    <Box
      {...chipProps}
      sx={{
        textAlign: "center",
        py: "auto",
        px: "1em",
        borderRadius: "12px",
        backgroundColor: chipColor,
        display: "flex",
        alignItems: "center",
        fontWeight: 500,
        lineHeight: "2em",
        height: "2em",
        overflow: "hidden",
        ...chipProps.sx,
        ...(color ? { color } : {}),
      }}
    >
      {body}
      {icon ? (
        <MaskedIcon
          src={icon}
          color={color}
          size={24}
          style={{ marginLeft: 4, flexShrink: 0 }}
        />
      ) : (
        resolvedMuiIcon && (
          <Box sx={{ display: "flex", alignItems: "center", pl: 1 }}>
            {resolvedMuiIcon}
          </Box>
        )
      )}
    </Box>
  );
  return (
    <Box {...cardProps} sx={{ ...cardProps.sx }}>
      {header && (
        <Box {...headerProps} sx={{ ...headerProps.sx }}>
          {header}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "left",
          height: "2em",
        }}
      >
        {tooltip ? (
          <Tooltip
            title={tooltip}
            placement="right"
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#fff",
                  color: "#414141",
                  border: "1px solid",
                  borderColor: "background.paper",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                  fontSize: "14px",
                  fontWeight: 400,
                  padding: "12px 16px",
                  borderRadius: "8px",
                },
              },
            }}
          >
            {chip}
          </Tooltip>
        ) : (
          chip
        )}
      </Box>
    </Box>
  );
};

export default TableUpdateStatusCell;
